import React from 'react'

export default function Configuration({ color }: { color: string }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.33333 4H6.66667V12H9.33333V4ZM25.3333 4H22.6667V17.3333H25.3333V4ZM4 17.3333H6.66667V28H9.33333V17.3333H12V14.6667H4V17.3333ZM20 9.33333H17.3333V4H14.6667V9.33333H12V12H20V9.33333ZM14.6667 28H17.3333V14.6667H14.6667V28ZM20 20V22.6667H22.6667V28H25.3333V22.6667H28V20H20Z" fill={color} />
    </svg>
  )
}
